import logoImg from "../assets/images/YESMLS_logo.png";
import loginImageImg from "../assets/images/login_bg.png";
import profileImageImg from "../assets/images/profile-image.png";
import profileAvatarImg from "../assets/images/profile_avater.png";
import defaultProfileAvatarImg from "../assets/images/user.png";

export const logo = logoImg;
export const loginImage = loginImageImg;
export const profileImage = profileImageImg;
export const profileAvatar = profileAvatarImg;
export const defaultProfileAvatar = defaultProfileAvatarImg;

// Check if search icon exists, if not you can add it later
// export const searchIcon = require('../assets/icons/search.svg')

